import { axiosInstance } from './api';

export default {
  getUsers: () => axiosInstance.get('/users'),
  getUserById: id => axiosInstance.get(`/users/${id}`),
  createUser: data => axiosInstance.post('/users', data),
  deleteUser: data => axiosInstance.delete(`/users/${data.id}`),
  updateUser: ({ id, data }) => axiosInstance.patch(`/users/${id}`, data)
};
